import { postWithJWT } from "./httpService";

export function save(credentials, apiEndpoint, data) {
  return postWithJWT(credentials, apiEndpoint, data);
}
